import { useEffect, useState } from "react";

const isWide = () => {
    const { innerWidth: width } = window;
    return width >= 1000;
};

export const useWideMode = () => {
    const [ wideMode, setWideMode ] = useState(isWide());

    useEffect(() => {
        const handleResize = () => {
            setWideMode(isWide());
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [])

    return wideMode;
};